<template>
  <div class="col-12">
    <div class="hrdivider"><hr /></div>
    <NewClientAddressClient :key="1" />
    <NewClientAddressClient
      v-if="clientAddressData"
      :key="2"
      :clientAddressData="clientAddressData"
    />
    <div class="direcciones-header">
      <h2>Elija una dirección de despacho</h2>
      <button data-toggle="modal" data-target="#nuevadireccion" class="btn btn-primary">
        <i class="fa fa-plus"></i> Crear nueva dirección
      </button>
    </div>
    <div class="direcciones-items" v-if="clientAddressList.length > 0">
      <div class="funkyradio">
        <div
          v-for="(address, index) in clientAddressList"
          :key="address.id_address"
          class="funkyradio-primary"
        >
          <input
            type="radio"
            name="direccion"
            :id="'direccion' + index"
            @click="selectClientAddressToProcess(address)"
          />
          <label :for="'direccion' + index"
            ><span>{{ address.id_district.desc_district + ', ' + address.address }}</span>
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#modificardireccion"
              @click="setAddressDetailsData(address)"
            >
              <i class="fa fa-pencil"></i><span>Modificar</span>
            </button>
            <template v-if="clientAddressList.length > 1">
              <button class="btn btn-danger" @click="deleteClientAddress(address.id_address)">
                <i class="fa fa-trash"></i><span>Eliminar</span>
              </button>
            </template>
          </label>
        </div>
      </div>
    </div>
    <div class="direcciones-items" v-if="clientAddressList.length === 0">
      <h4>
        <strong
          >Cree una nueva dirección de despacho para recibir sus productos en su domicilio</strong
        >
      </h4>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import NewClientAddressClient from '@/components/products/cart/CartProductsStepTwo/components/NewClientAddressClient';
import { generateRefreshTokenBodyRequest, getAccessToken } from '@/helpers/localStorage.helpers';
import { config_settings } from '@/config.js';
import { NOT_FOUND, UNAUTHORIZED } from '@/types/httpd.constants';
import { getAccountAddressList, deleteClientAddress } from '@/service/account.service.js';

export default {
  name: 'ClientAddressList',
  data() {
    return {
      clientAddressList: [],
      clientAddressData: null,
    };
  },
  components: { NewClientAddressClient },
  methods: {
    getClientAddressList() {
      getAccountAddressList(getAccessToken())
        .then((response) => {
          this.clientAddressList = response.data.clientaddress;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.getClientAddressList();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
              });
          } else if (error.response.status === NOT_FOUND) {
            this.clientAddressList = [];
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    setAddressDetailsData(address) {
      this.clientAddressData = address;
    },

    deleteClientAddress(id_address) {
      deleteClientAddress(id_address, getAccessToken())
        .then((response) => {
          this.getClientAddressList();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.deleteClientAddress(id_address);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: './inicio' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    selectClientAddressToProcess(address) {
      this.$parent.select_address(address);
    },
  },
  created() {
    this.getClientAddressList();
  },
};
</script>
